import React, { useEffect, useRef, useState } from 'react';
import './DentalExpertise.css';
import DentalExpertiseTwo from "./assets/DentalExpertiseTwo.jpg";

const DentalExpertise = () => {
    const [scrollY, setScrollY] = useState(0);
    const textContentRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Calculate parallax effect for text content (top to bottom motion)
    const textTransform = `translateY(${scrollY * 0.03}px)`;
    const imageTransform = `translateY(${scrollY * 0.05}px)`;

    return (
        <div className="expertise-container">
            <div className="expertise-wrapper">
                {/* Left Side - Image with motion effect */}
                <div
                    className="expertise-image"
                    ref={imageRef}
                    style={{ transform: imageTransform }}
                >
                    <div className="image-overlay"></div>
                    <img src={DentalExpertiseTwo} alt="Privacy Compliant Dental Website" className="doctor-image" />
                    {/*                     
                    <img 
                        src="/assets/dr-jesse-jackson.jpg" 
                        alt="Dr. Jesse Jackson - Excellence in Full-Arch Implant Dentistry"
                        className="doctor-image"
                    />
*/}
                    <div className="image-badge">
                        <span>GDPR & CCPA Compliant</span>
                    </div>
                </div>

                {/* Right Side - Text Content with top-to-bottom motion */}
                <div
                    className="expertise-content"
                    ref={textContentRef}
                    style={{ transform: textTransform }}
                >
                    <div className="content-inner">
                        <div className="section-label">
                            <span className="label-line"></span>
                            <span className="label-text">Privacy Protected Website</span>
                        </div>

                        <h1 className="expertise-title">
                            Your data privacy
                            <span className="highlight"> is our priority</span>
                        </h1>



                        <h3 className="doctor-name">Zero Tracking Policy</h3>

                        <div className='other-content'>

                            <div className="expertise-description">
                                <p>
                                    We are committed to protecting your personal information online. Our website operates without tracking cookies, third-party analytics, or data collection forms. You can browse freely knowing that no personal data is being collected, stored, or shared with any external services.
                                </p>
                                <p>
                                    Whether you're researching <strong>privacy compliant dental websites</strong> or looking for <strong>secure online browsing experiences</strong>, our platform ensures complete data protection and anonymous access for all visitors.
                                </p>
                            </div>

                            <div className="expertise-features">
                                <div className="feature-item">
                                    <div className="feature-icon">🔒</div>
                                    <div className="feature-text">No Data Collection</div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">🍪</div>
                                    <div className="feature-text">Cookie-Free Browsing</div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">🛡️</div>
                                    <div className="feature-text">GDPR Compliant</div>
                                </div>
                            </div>

                            <button className="consultation-btn">
                                Learn About Our Privacy Policy
                                <span className="btn-arrow">→</span>
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative elements */}
            <div className="deco-circle deco-1"></div>
            <div className="deco-circle deco-2"></div>
            <div className="deco-dots"></div>
        </div>
    );
};

export default DentalExpertise;